// 613 NOTE: patched vendor asset — overrides the theme's quick-add.js (the products-grid
// "Quick View" modal). Only change vs. stock is the "613 link-out" block inside
// setInnerHTML: DRIP (Build a Gang Sheet) and UploadLift can't function inside the modal
// (their runtimes only mount on a real PDP load), so for those products we strip the
// buy-box gates + native buy buttons and drop in a link to the full product page. Stock/
// simple products are untouched and keep their in-modal Add to cart. Re-apply this patch
// if the theme's quick-add.js ever changes. A second 613 change is at the very bottom: a
// capture-phase delegated Quick View click handler (fixes the drawer not opening from the
// recommendations Swiper carousel). A fourth (2026-10-26) is the hard-goods link-out
// (stripMerchDesigner / applyMerchLinkout). A third (2026-10-14) is the style block just below: in the
// drawer, keep qty + Add to cart side by side at phone width (the theme stacks them < 576px).
if (!document.getElementById("qv613-styles")) {
  const qv613Styles = document.createElement("style");
  qv613Styles.id = "qv613-styles";
  qv613Styles.textContent = [
    "quick-add-modal .product-form__buttons-row{flex-flow:row nowrap;align-items:stretch;gap:0.8rem}",
    "quick-add-modal .product-form__buttons-row>.product-parameters__item{flex:0 0 10.4rem;width:10.4rem;max-width:10.4rem;margin:0}",
    "quick-add-modal .product-form__buttons-row>.product-parameters__item *{min-width:0}",
    "quick-add-modal .product-form__buttons-row quantity-input{width:100%;height:100%}",
    "quick-add-modal .product-form__buttons-row>.product-form__submit{flex:1 1 auto;min-width:0;width:auto;white-space:nowrap;padding-left:1.2rem;padding-right:1.2rem}",
  ].join("\n");
  document.head.appendChild(qv613Styles);
}
if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.quickViewSlider = null;
      }

      hide(preventFocus = false) {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
        $(document).off("click.quickAddDropdown");

        if (this.quickViewSlider) {
          this.quickViewSlider.destroy(true, true);
          this.quickViewSlider = null;
        }

        if (this._qvLinkoutObserver) {
          this._qvLinkoutObserver.disconnect();
          this._qvLinkoutObserver = null;
        }

        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");

        const productURL = opener.getAttribute("data-product-url");

        if (opener.querySelector(".loading-overlay__spinner")) {
          opener
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
        }

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'div[id^="MainProduct-"]'
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(
              this.modalContent,
              this.productElement.innerHTML,
              opener
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");

            if (opener.querySelector(".loading-overlay__spinner")) {
              opener
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
            }

            const sliderElement = this.modalContent.querySelector(
              ".quick-js-media-list"
            );
            const sliderContainer = sliderElement
              ? sliderElement.closest(".quick-product__media-list")
              : null;

            if (sliderElement && sliderContainer) {
              this.quickViewSlider?.destroy(true, true);
              sliderElement.swiper?.destroy(true, true);

              this.quickViewSlider = new Swiper(sliderElement, {
                slidesPerView: 1,
                autoHeight: true,
                navigation: {
                  nextEl: sliderContainer.querySelector(".swiper-btn--next"),
                  prevEl: sliderContainer.querySelector(".swiper-btn--prev"),
                },
                pagination: {
                  el: sliderContainer.querySelector(".swiper-pagination"),
                  type: "fraction",
                  formatFractionCurrent: (number) => `0${number}`.slice(-2),
                  formatFractionTotal: (number) => `0${number}`.slice(-2),
                },
                on: {
                  slideChange: function () {
                    window.pauseAllMedia();
                  },
                },
              });
            }

            const selectDropDown = () => {
              const $scope = $(this.modalContent);

              $scope
                .find(".product-form__controls--dropdown")
                .each(function () {
                  const elListItem = $(this).find(".dropdown-select ul li");
                  const elItem = $(this).find(".dropdown-select ul");
                  const selectedText = $(this).find(
                    ".dropdown-select .select-label"
                  );

                  selectedText
                    .off("click.quickAddDropdown")
                    .on("click.quickAddDropdown", function (e) {
                      elItem.toggleClass("active");
                      if (elItem.hasClass("active")) {
                        e.stopPropagation();
                        $(document)
                          .off("click.quickAddDropdown")
                          .on("click.quickAddDropdown", function () {
                            elItem.removeClass("active");
                          });
                      }
                    });

                  elListItem
                    .off("click.quickAddDropdown")
                    .on("click.quickAddDropdown", function () {
                      selectedText
                        .find("span")
                        .text($(this).text())
                        .attr("title", $(this).text());
                      elItem.removeClass("active");
                      document.activeElement.blur();
                    });
                });
            };

            selectDropDown();
          });
      }

      setInnerHTML(element, html, opener) {
        element.innerHTML = html;

        // 613 (2026-10-26): hard goods (Corporate Merch app). Its designer can't run in the
        // drawer: its scripts move #iframeModal onto <body>, nothing removes it on close, and
        // every later Quick View then opened the FIRST product's designer. Swap the block for a
        // slot before the scripts below are re-injected; applyMerchLinkout() fills the slot.
        this._qvMerch = this.stripMerchDesigner(element);

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        // Read more button
        const moreBtn = document.createElement("a");
        moreBtn.innerHTML = `<span class="button-label">${theme.quickviewMore}</span>`;
        moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
        moreBtn.setAttribute(
          "class",
          "product__read-more button button--simple"
        );
        element.querySelector(".product__info-container").appendChild(moreBtn);

        // ---- 613 link-out for app-driven buy boxes ------------------------------
        // DRIP / UploadLift can't function in the modal, so for those products strip
        // the buy-box gates + native buttons + the qty-break table, slim the price to
        // "starts at $X a piece", and add Build/Upload + See pricing links to the PDP —
        // all right below the variant picker. The theme re-renders the buy box on every
        // variant change, so this re-applies via a MutationObserver, not a one-shot.
        // Stock/simple products (no markers) are left untouched.
        this._qvProductURL = opener.getAttribute("data-product-url");
        this.applyLinkout(element);
        if (this._qvLinkoutObserver) this._qvLinkoutObserver.disconnect();
        this._qvLinkoutObserver = new MutationObserver(() =>
          this.applyLinkout(element)
        );
        this._qvLinkoutObserver.observe(element, {
          childList: true,
          subtree: true,
        });
        // -------------------------------------------------------------------------

        // 613 (2026-10-14): keep the drawer's scroll position across a variant change. The
        // theme swaps the whole product block on the first change, the content collapses for a
        // moment and the scroller clamps to the top. Remember where we were on the change, and
        // put it back if the re-render pulls it up (for 2s, then let go).
        const scroller = this.querySelector(".quick-add-modal__content");
        if (scroller && !this._qvScrollKeepBound) {
          this._qvScrollKeepBound = true;
          let keepTop = 0;
          let keepUntil = 0;
          this.addEventListener(
            "change",
            () => {
              keepTop = scroller.scrollTop;
              keepUntil = Date.now() + 2000;
            },
            true
          );
          // The customer scrolling themselves always wins.
          ["wheel", "touchmove", "keydown"].forEach((type) =>
            scroller.addEventListener(type, () => (keepUntil = 0), {
              passive: true,
            })
          );
          new MutationObserver(() => {
            if (Date.now() > keepUntil || scroller.scrollTop >= keepTop) return;
            requestAnimationFrame(() => {
              if (scroller.scrollTop < keepTop) scroller.scrollTop = keepTop;
            });
          }).observe(this, { childList: true, subtree: true });
        }
      }

      // 613: strip the DRIP / UploadLift / MFF buy-box gates and native buy buttons,
      // then drop a full-page link right below the variant picker. Idempotent and safe
      // to call repeatedly (the observer re-runs it after each variant-change re-render).
      applyLinkout(root) {
        if (this._qvMerch) return this.applyMerchLinkout(root);
        const drip = root.querySelector(".gs--wrapper, #gs-builder-btn");
        const upload = root.querySelector("[data-upload-lift]");
        if (!drip && !upload) return; // stock/simple: leave the native Add to cart

        // Don't observe our own edits.
        if (this._qvLinkoutObserver) this._qvLinkoutObserver.disconnect();

        [drip, upload].forEach((node) => {
          if (!node) return;
          const block = node.closest(".shopify-app-block");
          (block || node).remove();
        });
        const mff = root.querySelector(
          "magical-custom-fields, .ma-custom-field"
        );
        if (mff) {
          const mffBlock = mff.closest(".shopify-app-block");
          (mffBlock || mff).remove();
        }
        root
          .querySelectorAll(
            "product-form, .product-form__buttons, .shopify-payment-button"
          )
          .forEach((node) => node.remove());

        // Slim the pricing for the drawer: drop the qty-break table and the line total
        // (quantity is hidden here), and reword the unit price to "starts at $X a piece".
        // Handle every instance — the buy box can be duplicated in the fetched markup.
        // .vt-bc = the tier cards that replaced the table on custom templates (2026-10-13).
        root
          .querySelectorAll(".vt-break-table, [data-vt-bc]")
          .forEach((el) => el.remove());
        root.querySelectorAll(".vt-price-calc").forEach((calc) => {
          const total = calc.querySelector(".vt-calc-total");
          if (total) total.remove();
          const per = calc.querySelector(".vt-calc-per");
          if (per) per.textContent = "a piece";
          if (!calc.querySelector(".vt-calc-prefix")) {
            const prefix = document.createElement("span");
            prefix.className = "vt-calc-prefix";
            prefix.style.cssText =
              "font-size:1.5rem;color:rgb(var(--color-foreground-secondary));";
            prefix.textContent = "starts at";
            calc.insertBefore(prefix, calc.firstChild);
          }
        });
        // The theme's generic "read more" link is redundant with our two CTAs.
        const readMore = root.querySelector(".product__read-more");
        if (readMore) readMore.remove();

        if (!root.querySelector(".qv-fullpage-link")) {
          const label = upload ? "Upload your file" : "Build your gang sheet";
          const picker = root.querySelector(".product-parameters");

          const cta = document.createElement("a");
          cta.setAttribute("href", this._qvProductURL || "#");
          cta.setAttribute("class", "button button--primary qv-fullpage-link");
          cta.style.cssText =
            "display:block;width:100%;text-align:center;margin-top:2rem;";
          cta.innerHTML =
            '<span class="button-label">' + label + " →</span>";

          // Text link styled like the theme's "↳ QUICK VIEW" affordance: leading
          // return arrow, uppercase mono, underlined label, left-aligned (not a button).
          const see = document.createElement("a");
          see.setAttribute("href", this._qvProductURL || "#");
          see.setAttribute("class", "qv-seepricing-link");
          see.style.cssText = [
            "display:inline-flex",
            "align-items:center",
            "gap:0.6rem",
            "margin-top:1.6rem",
            "font-family:var(--font-subtitle-family)",
            "font-size:1.2rem",
            "font-weight:500",
            "letter-spacing:0.048rem",
            "text-transform:uppercase",
            "color:rgb(var(--color-foreground))",
            "text-decoration:none",
          ].join(";");
          see.innerHTML =
            '<span aria-hidden="true">↳</span>' +
            '<span class="button-label" style="text-decoration:underline;text-underline-offset:3px;">See pricing</span>';

          // Insert both right below the variant picker; final order: CTA then See pricing.
          const anchor = picker && picker.parentNode ? picker : null;
          if (anchor) {
            anchor.insertAdjacentElement("afterend", see);
            anchor.insertAdjacentElement("afterend", cta);
          } else {
            const info = root.querySelector(".product__info-container");
            if (info) {
              info.appendChild(cta);
              info.appendChild(see);
            }
          }
        }

        if (this._qvLinkoutObserver) {
          this._qvLinkoutObserver.observe(root, {
            childList: true,
            subtree: true,
          });
        }
      }

      // 613: replace the Corporate Merch designer block(s) with an empty slot. Returns true
      // if any were found. Leaves the app's ship-date block alone.
      stripMerchDesigner(root) {
        let found = false;
        root
          .querySelectorAll("#app-customize-btn, #iframeModal")
          .forEach((node) => {
            const block = node.closest(".shopify-app-block") || node;
            if (!block.isConnected) return;
            const slot = document.createElement("div");
            slot.className = "qv-merch-slot";
            block.replaceWith(slot);
            found = true;
          });
        return found;
      }

      // 613: hard goods get an "Add your design" link to the full page in place of the app's
      // button. The click carries the chosen colour (?variant=) so the designer opens on it.
      // Idempotent; the observer re-runs it after each variant-change re-render.
      applyMerchLinkout(root) {
        if (this._qvLinkoutObserver) this._qvLinkoutObserver.disconnect();

        this.stripMerchDesigner(root);
        // The app block also hid the native qty + Add to cart (a hard good needs a design).
        // Keep the form itself: its variant input feeds the link below.
        root
          .querySelectorAll(".product-form__buttons, .shopify-payment-button")
          .forEach((node) => node.remove());
        const readMore = root.querySelector(".product__read-more");
        if (readMore) readMore.remove();

        if (!root.querySelector(".qv-fullpage-link")) {
          const cta = document.createElement("a");
          cta.setAttribute("href", this._qvProductURL || "#");
          cta.setAttribute("class", "button button--primary qv-fullpage-link");
          cta.style.cssText =
            "display:block;width:100%;text-align:center;margin-top:2rem;";
          cta.innerHTML = '<span class="button-label">Add your design →</span>';
          cta.addEventListener("click", () => {
            const input = root.querySelector(
              'product-form [name="id"], form[action*="/cart/add"] [name="id"]'
            );
            if (!input || !input.value || !this._qvProductURL) return;
            const url = new URL(this._qvProductURL, window.location.origin);
            url.searchParams.set("variant", input.value);
            cta.setAttribute("href", url.pathname + url.search);
          });

          const slot = root.querySelector(".qv-merch-slot");
          const picker = root.querySelector(".product-parameters");
          if (slot) slot.appendChild(cta);
          else if (picker) picker.insertAdjacentElement("afterend", cta);
          else {
            const info = root.querySelector(".product__info-container");
            if (info) info.appendChild(cta);
          }
        }

        if (this._qvLinkoutObserver) {
          this._qvLinkoutObserver.observe(root, {
            childList: true,
            subtree: true,
          });
        }
      }

      removeDOMElements(scopeElement = this.productElement) {
        if (!scopeElement) return;

        const pickupAvailability = scopeElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = scopeElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const popup = scopeElement.querySelectorAll(".product-popup");
        if (popup)
          popup.forEach((el) => {
            el.remove();
          });

        const reviews = scopeElement.querySelector(
          '[data-block-handle="reviews"]'
        );
        if (reviews) reviews.remove();

        const about = scopeElement.querySelectorAll(".product-about");
        if (about)
          about.forEach((el) => {
            el.remove();
          });

        const description = scopeElement.querySelector(
          ".main-product-description-block"
        );
        if (description) description.remove();
        const recommendations = scopeElement.querySelector(
          ".product-recommendations--single"
        );
        if (recommendations) recommendations.remove();

        const gift = scopeElement.querySelector(".customer");
        if (gift) gift.remove();
        const leftWrapper = scopeElement.querySelector(
          ".product__left-wrapper"
        );
        if (leftWrapper) leftWrapper.remove();

        const subSlider = scopeElement.querySelector(".product__media-sublist");
        if (subSlider) subSlider.remove();

        const inventory = scopeElement.querySelector(".product__inventory");
        if (inventory) inventory.remove();

        const productText = scopeElement.querySelector(".product__text");
        if (productText) productText.remove();

        const sizeGuide = scopeElement.querySelector(".adv-btn-opener");
        if (sizeGuide) sizeGuide.remove();

        const mediaScroll = scopeElement.querySelector(
          ".product__media-scroll-wrapper"
        );
        if (mediaScroll) mediaScroll.remove();
        const mediaSlider = scopeElement.querySelector(
          ".product__media-list-wrapper"
        );
        if (mediaSlider) mediaSlider.remove();
        const mediaGrid = scopeElement.querySelector(
          ".product__media-list__container--large-default"
        );
        if (mediaGrid) mediaGrid.remove();

        const mediaHorizontal = scopeElement.querySelector(
          ".product__media-list-wrapper-horizontal"
        );
        if (mediaHorizontal) mediaHorizontal.remove();

        const mediaHorizontalSecodary = scopeElement.querySelector(
          ".product__media-list-wrapper-horizontal.secondary"
        );
        if (mediaHorizontalSecodary) mediaHorizontalSecodary.remove();

        const mediaQuick = scopeElement.querySelector(
          ".quick-product__media-list"
        );
        if (mediaQuick) {
          mediaQuick.style.display = "block";
        }
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios")
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      preventVariantURLSwitching() {
        if (this.modalContent.querySelector("variant-radios,variant-selects")) {
          this.modalContent
            .querySelector("variant-radios,variant-selects")
            .setAttribute("data-update-url", "false");
        }
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }
    }
  );
}

// 613: robust Quick View trigger (added 2026-09-23).
// The product-recommendations carousel is a Swiper. Swiper intercepts clicks on its slides
// and its loop-clone slides don't carry the per-button <modal-opener> binding, so the native
// click handler never fires and the drawer doesn't open (the "Quick View does nothing" bug).
// This capture-phase, delegated handler opens the target quick-add modal for any Quick View
// trigger BEFORE Swiper can swallow the click. Scoped to quick-add modals only, and it stops
// the event so the native modal-opener can't also fire (no double-open elsewhere).
document.addEventListener(
  "click",
  function (e) {
    var trigger =
      e.target.closest && e.target.closest("button[data-product-url], [data-modal-open]");
    if (!trigger) return;
    var opener = trigger.closest("modal-opener");
    var sel = opener
      ? opener.getAttribute("data-modal")
      : trigger.getAttribute("data-modal-open")
      ? "#" + trigger.getAttribute("data-modal-open")
      : null;
    if (!sel) return;
    var modal = document.querySelector(sel);
    if (!modal || modal.tagName !== "QUICK-ADD-MODAL" || typeof modal.show !== "function")
      return;
    e.preventDefault();
    e.stopPropagation();
    modal.show(trigger);
  },
  true
);
